import React from 'react';
import {
    Button,
    Icon,
    PriorityIcon,
    TriggerWrapperV2
} from '@priority-software/priority-style-react';
import {automationMenuTriggerRef} from './automationMenuTriggerRef';
import texts from '../texts';

import styles from '../styles/MacroMenu.module.scss';

export const ButtonTrigger = ({isOpen, onClick, componentClasses = ''}) => (
    <TriggerWrapperV2 isOpen={isOpen}>
        <Button
            componentClasses={componentClasses}
            inputRef={automationMenuTriggerRef}
            skin="text"
            onClick={onClick}
            prefixIcon={PriorityIcon.automations}
            suffixIcon={
                <Icon
                    componentClasses={isOpen ? styles.menuArrow : ''}
                    icon={PriorityIcon.arrowDropDown}
                />
            }
        >
            <span className={styles.headerButtonText}>{texts.menu_trigger}</span>
        </Button>
    </TriggerWrapperV2>
);
